/* American Premium shell UI, loaded before the cart and page scripts.
   1. Input modality for focus rings (MASI R66 precedent). WebKit can mark a dialog's first control, or focus restored
      after a dialog closes, as focus-visible after a tap. A pointer press marks html[data-ap-input="pointer"], so
      ap-theme.css keeps those rings quiet. Navigation keys (Tab, arrows, Home/End, Page Up/Down, Escape) switch it back
      to "keyboard", and so do Enter and Space on a control (button, link, summary, radio); typing into a text field,
      textarea or editable text on a phone keyboard, Enter included, does not bring the rings back.
   2. While any dialog is open, html.ap-modal-open stops the page behind it from scrolling; its position is kept. */
(() => {
  const root = document.documentElement;
  const NAV_KEYS = new Set(['Tab', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'PageUp', 'PageDown', 'Escape']);
  document.addEventListener('pointerdown', () => { root.dataset.apInput = 'pointer'; }, {capture: true, passive: true});
  const NOT_TEXT = new Set(['checkbox', 'radio', 'button', 'submit', 'reset', 'image', 'file', 'range', 'color']);
  const editingText = el => !!el && (el.isContentEditable || el.tagName === 'TEXTAREA' || (el.tagName === 'INPUT' && !NOT_TEXT.has(el.type)));
  document.addEventListener('keydown', e => {
    if (e.metaKey || e.ctrlKey || e.altKey) return;
    const activates = (e.key === 'Enter' || e.key === ' ') && !editingText(e.target);
    if (NAV_KEYS.has(e.key) || activates) root.dataset.apInput = 'keyboard';
  }, {capture: true});

  const syncModal = () => root.classList.toggle('ap-modal-open', !!document.querySelector('dialog[open]'));
  new MutationObserver(syncModal).observe(root, {subtree: true, attributes: true, attributeFilter: ['open']});
  syncModal();
})();
